/* eslint-disable */
const routeService = [
  {
		path: '/service',
		name: 'Service',
		component: () => import('../components/ServiceTemplate/ServiceTemplate.vue'),
		meta: {
			layout: 'HomeLayout',
		},
	},
]

export default routeService;